/**
 * Frequency cap: a popup can show at most once per session and once every 7 days
 * per visitor on this device. Server `lead_popup_dismissals` handles cross-device.
 */
const SESSION_KEY = (id: string) => `lp_session:${id}`;
const LOCAL_KEY = (id: string) => `lp:${id}`;
const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;

export function canShow(popupId: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (sessionStorage.getItem(SESSION_KEY(popupId))) return false;
    const raw = localStorage.getItem(LOCAL_KEY(popupId));
    if (raw) {
      const ts = Number(raw);
      if (Number.isFinite(ts) && Date.now() - ts < SEVEN_DAYS) return false;
    }
  } catch {
    /* ignore */
  }
  return true;
}

export function markShown(popupId: string) {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(SESSION_KEY(popupId), "1");
    localStorage.setItem(LOCAL_KEY(popupId), String(Date.now()));
  } catch {
    /* ignore */
  }
}
